import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { GEO_LABELS } from '../../data/geo';

// "Verwandte Themen" – descriptive internal links (3–4).
const RelatedTopics = ({ items = [] }) => {
  const { lang } = useLang();
  if (!items.length) return null;
  return (
    <section aria-label={GEO_LABELS[lang].relatedTitle}>
      <h2 className="text-[13px] font-bold uppercase tracking-[0.2em] text-slate-500">{GEO_LABELS[lang].relatedTitle}</h2>
      <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map((it, i) => (
          <li key={i}>
            <Link to={it.to} className="group flex items-center justify-between gap-3 p-4 rounded-lg bg-white border border-slate-200 hover:border-blue-300 hover:shadow-sm transition">
              <span className="text-[14px] font-semibold text-slate-800 group-hover:text-blue-700 transition-colors">{it[lang]}</span>
              <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-blue-600 shrink-0 transition-colors" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RelatedTopics;
